import axios, { AxiosRequestConfig } from 'axios';
import { useMutation } from 'react-query';

export const useSubmit = <T>(url: string, axiosCfg: AxiosRequestConfig = {}) => {
  const mutation = useMutation({
    mutationFn: async (data: MutationFnParams): Promise<T> => {
      const { __axios, ...body } = data;
      const axiosRes = await axios.request({
        url,
        method: 'POST',
        data: body,
        ...axiosCfg,
        ...__axios,
      });
      return axiosRes.data;
    },
  });

  return mutation;
};

type MutationFnParams = AxiosRequestConfig['data'] & {
  __axios: AxiosRequestConfig;
};
